import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { alpha, useTheme } from "@mui/material/styles"


export const LogsHeader = () =>
{
  const theme = useTheme()
  return(
    <TableHead>
          <TableRow>
            <TableCell sx={styles.header(theme)}>Event Time</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Market Id</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Reason</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Price (USD)</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Crypto Qty</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Amount</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Profit</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Fee</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>RSI</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>MFI</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Total Assets</TableCell>
          </TableRow>
        </TableHead>
  )
}

const styles = {
  header: (theme: any) => ({
    fontWeight: 700,
    backgroundColor: alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.16 : 0.03),
    backdropFilter: "blur(10px)",
  }),
}
